export const fetchStatus = {
    notStarted: "notStarted",
    completed: "completed",
    loading: "loading",
};
